import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import FlexPane from '../../../../VentoryUI/components/common/FlexPane';
import SearchBarWithFilter from '../../../../VentoryUI/components/common/SearchBarWithFilter';
import { t } from '../../../../types/translation/Translator';
import Table from '../../../components/Table';
import { AssetContext } from '../../../../context/AssetContext';
import { Asset } from '../../../../types/asset/asset';
import { AssetFilter } from '../../../../VentoryUI/components/filters/AssetFilter/AssetFilter';
import { AssetTable } from '../../Common/AssetTable';
import { ProductMasterDataContext } from '../../../../context/ProductMasterDataContext';
import { CompanyContext } from '../../../../context/CompanyContext';
import { UserContext } from '../../../../context/UserContext';
import { Grid } from '@mui/material';
import { AssetTransactionContext } from '../../../../context/AssetTransactionContext';
import { CustomFieldContext } from '../../../../context/CustomFieldContext';
import { TagRelationContext } from '../../../../context/TagRelationContext';
import { TableSettingsContext } from '../../../../context/TableSettingsContext';
import { EntityType } from '../../../../types/comment';

export default function UserAssetOverviewPane() {
  const { currentCompany } = useContext(CompanyContext);
  const { productMasterData, productMasterDataLoading } = useContext(ProductMasterDataContext);
  const { assets, assetsLoading } = useContext(AssetContext);
  const { assetTransactions } = useContext(AssetTransactionContext);
  const { getTableSettings } = useContext(TableSettingsContext);
  const { companyUsers, currentUser, locale } = useContext(UserContext);
  const { customFields } = useContext(CustomFieldContext);
  const { tagRelations } = useContext(TagRelationContext);

  const assetTableSettings = getTableSettings(EntityType.asset, currentCompany.id);

  const items = useMemo(() => {
    return [...assets.values()].filter(asset => currentUser?.id && asset.location?.entityId === currentUser.id);
  }, [assets]);

  const [filteredItems, setFilteredItems] = useState<Asset[]>(items);

  const filter = new AssetFilter(
    productMasterData,
    companyUsers,
    assets,
    assetTransactions,
    assetTableSettings,
    customFields,
    tagRelations,
    currentCompany,
  );

  return (
    <>
      <FlexPane
        header={
          <SearchBarWithFilter
            loading={assetsLoading || productMasterDataLoading}
            items={items}
            setItems={setFilteredItems}
            placeholder={t(TranslationKey.searchForAsset).plural.label}
            filter={filter}
          />
        }
        content={
          <Grid container rowSpacing={1} alignContent={'start'} className='h-full'>
            <Grid item xs={12} className='h-full'>
              <Table
                loading={assetsLoading || productMasterDataLoading}
                items={filteredItems}
                totalItemCount={items.length}
                headers={AssetTable.header(
                  productMasterData,
                  companyUsers,
                  assetTableSettings,
                  true,
                  locale,
                  currentCompany,
                )}
                filter={filter}
              />
            </Grid>
          </Grid>
        }
      />
    </>
  );
}
